export const keyCodes = {
    enter: 13,
    esc: 27,
    tab: 9,
};

export const mouseCodes = {
    left: 0,
}
